'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type TTalentLayoutProps = {
  children: React.ReactNode;
};

const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

export const ReactQueryProvider: React.FC<TTalentLayoutProps> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={reactQueryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
